/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_RagInputs */

const en_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const ar_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#استرجاع`)
};

const bn_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const de_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const es_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const fr_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const pt_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const zh_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const tr_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const ru_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

const pl_svtag_rag = /** @type {(inputs: Svtag_RagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#RAG`)
};

/**
* | output |
* | --- |
* | "#RAG" |
*
* @param {Svtag_RagInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_rag = /** @type {((inputs?: Svtag_RagInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_RagInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_rag(inputs)
	if (locale === "bn") return bn_svtag_rag(inputs)
	if (locale === "de") return de_svtag_rag(inputs)
	if (locale === "es") return es_svtag_rag(inputs)
	if (locale === "fr") return fr_svtag_rag(inputs)
	if (locale === "pt") return pt_svtag_rag(inputs)
	if (locale === "zh") return zh_svtag_rag(inputs)
	if (locale === "tr") return tr_svtag_rag(inputs)
	if (locale === "ru") return ru_svtag_rag(inputs)
	if (locale === "pl") return pl_svtag_rag(inputs)
	return en_svtag_rag(inputs)
});